// 提交 mutations是更改Vuex状态的唯一合法方法
import cloneDeep from 'lodash/cloneDeep'

export const resetStore = (state) => {
  Object.keys(state).forEach((key) => {
    state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
  })
}

